import React from 'react';
import PropTypes from 'prop-types';
import { SectionIntro, BackgroundColorContainer } from '../../atoms';
import { HoverImageCard } from '../HoverImageCard';
import { Carousel } from '../../molecules';
import { CtaButton } from '../CtaButton';
import { useReporter } from '../../reporter';
import { infoCardsButtonClicked } from './events';
import {
  StyledImageCardsList,
  ImageCardsListContainer,
  MobileImageCardsListContainer,
  CardWrapper,
  ButtonContainer,
} from './styles.js';

export const HoverImageCards = ({
  headline,
  subheadline,
  items,
  isCarousel = true,
  link,
  buttonVariant = 'primary',
  backgroundColor = 'background.base',
}) => {
  const reporter = useReporter();
  return (
    <BackgroundColorContainer bgColor={backgroundColor}>
      <StyledImageCardsList>
        {(headline || subheadline) && (
          <SectionIntro headline={headline} subheadline={subheadline} />
        )}
        <ImageCardsListContainer count={items.length} isCarousel={isCarousel}>
          {items.map((item, i) => (
            <CardWrapper key={i}>
              <HoverImageCard {...item} />
            </CardWrapper>
          ))}
        </ImageCardsListContainer>
        <MobileImageCardsListContainer isCarousel={isCarousel}>
          <Carousel buttonPosition="40" dotPadding={6} showDots={false}>
            {items.map((item, i) => (
              <CardWrapper key={i}>
                <HoverImageCard {...item} />
              </CardWrapper>
            ))}
          </Carousel>
        </MobileImageCardsListContainer>
        {link && (
          <ButtonContainer>
            <CtaButton
              href={link.target}
              variant={buttonVariant}
              onClick={() =>
                reporter.tag(infoCardsButtonClicked(link.text, link.target))
              }
            >
              {link.text}
            </CtaButton>
          </ButtonContainer>
        )}
      </StyledImageCardsList>
    </BackgroundColorContainer>
  );
};

HoverImageCards.displayName = 'ImageCardsList';

HoverImageCards.propTypes = {
  headline: PropTypes.string,
  subheadline: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isCarousel: PropTypes.bool,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }),
  buttonVariant: PropTypes.string,
  backgroundColor: PropTypes.string,
};
